import PropTypes from 'prop-types';
import React from 'react';
import Menu from './menu';
import EditionSwitch from './edition_switch';
import {isEmpty} from 'lodash';
import classNames from 'classnames';
import { BeautyconLogo, RefineryLogo, SomosLogo, UnbotheredLogo } from './vertical_logos';
import {HEADER_LINKS} from "../../constants";
import { sendDataLayerEvent } from '../../utils/analytics';
import { setLocation } from '../../utils/dom';

const HamburgerMenuIcon = (<svg width="20" height="15" viewBox="0 0 20 15" fill="black" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="20" height="2" rx="1" fill="#333333"/><rect y="6.5" width="15" height="2" rx="1" fill="#333333"/><rect y="12.5" width="20" height="2" rx="1" fill="#333333"/></svg>);
const CloseIcon = (<svg width="44" height="44" viewBox="0 0 44 44" fill="black" xmlns="http://www.w3.org/2000/svg"><rect x="14.2219" y="28.364" width="20" height="2" rx="1" transform="rotate(-45 14.2219 28.364)" fill="#333333"/><rect x="28.7637" y="29.3785" width="20" height="2" rx="1" transform="rotate(-135 28.7637 29.3785)" fill="#333333"/></svg>)

const Aux = props => props.children;

export default class HeaderElements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {menuOpen: false};
  }


  toggleMenu = (event) => {
    this.props.setMenuIsOpen(!this.state.menuOpen);
    sendDataLayerEvent('nav_item_click', {data: {navLocation: 'header', navItem: `${this.state.menuOpen ? 'close' : 'open'}_menu`}});
    this.setState({menuOpen: !this.state.menuOpen});
  }

  handleDataLayerEvent = (event, data, url) => {
    event.preventDefault();
    sendDataLayerEvent('nav_item_click', {data: {navLocation: 'header', navItem:data}}, true, url);
  }


  editionSwitch = !isEmpty(this.props.edition_data) &&
    <EditionSwitch edition_data={this.props.edition_data} alternate_urls={this.props.alternate_urls} />;

  editionBaseName = !isEmpty(this.props.edition_data) && this.props.edition_data.basename ? this.props.edition_data.basename : 'en-us';

  render() {
    return (
      <Aux>
          <div className={classNames('global-header-main', {'menu-open': this.state.menuOpen})}>
            <Menu
              menuOpen={this.state.menuOpen}
              navigationItems={this.props.navigationItems}
              edition_data={this.props.edition_data}
              alternate_urls={this.props.alternate_urls}
              closeMenu={this.toggleMenu}
              recordSearchTerm={this.props.recordSearchTerm}/>
            <button
              type="button"
              className={classNames('hamburger-menu', 'desktop', {'is-open': this.state.menuOpen})}
              onClick={this.toggleMenu}
              aria-label={this.state.menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={this.state.menuOpen ? 'true' : 'false'}
              aria-controls="main-menu"
            >
              {this.state.menuOpen ? CloseIcon : HamburgerMenuIcon}
            </button>
            <div className="header-verticals desktop">
              <a href={HEADER_LINKS[this.editionBaseName].R29} onClick={(e) => this.handleDataLayerEvent(e, 'refinery29', HEADER_LINKS[this.editionBaseName].R29)}>{RefineryLogo}</a>
              <a href={HEADER_LINKS[this.editionBaseName].Unbothered} onClick={(e) => this.handleDataLayerEvent(e, 'unbothered', HEADER_LINKS[this.editionBaseName].Unbothered)}>{UnbotheredLogo}</a>
              <a href={HEADER_LINKS[this.editionBaseName].Somos} onClick={(e) => this.handleDataLayerEvent(e, 'somos', HEADER_LINKS[this.editionBaseName].Somos)}>{SomosLogo}</a>
              <a href="https://www.beautycon.com/" onClick={(e) => this.handleDataLayerEvent(e, 'beautycon', 'https://www.beautycon.com/')}>{BeautyconLogo}</a>
            </div>
            <div className="header-verticals desktop r29-only-menu">
              <a href={HEADER_LINKS[this.editionBaseName].R29} onClick={(e) => this.handleDataLayerEvent(e, 'refinery29', HEADER_LINKS[this.editionBaseName].R29)}>{RefineryLogo}</a>
            </div>
            <div className="header-mobile-logo mobile">
              <a href={HEADER_LINKS[this.editionBaseName].R29} onClick={(e) => this.handleDataLayerEvent(e, 'refinery29', HEADER_LINKS[this.editionBaseName].R29)}>{RefineryLogo}</a>
            </div>
            <div className="desktop edition-switch-wrapper">
              {this.editionSwitch}
            </div>
            <div className="mobile edition-switch-wrapper">
              {this.state.menuOpen && this.editionSwitch}
            </div>
            <button
              type="button"
              className={classNames('hamburger-menu', 'mobile', {'is-open': this.state.menuOpen})}
              onClick={this.toggleMenu}
              aria-label={this.state.menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={this.state.menuOpen ? 'true' : 'false'}
              aria-controls="main-menu"
            >
              {this.state.menuOpen ? CloseIcon : HamburgerMenuIcon}
            </button>
          </div>
      </Aux>
    );
  }
};

HeaderElements.propTypes = {
  page_type: PropTypes.string,
  pageId: PropTypes.number,
  edition_data: PropTypes.object,
  alternate_urls: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  trendingItems: PropTypes.shape({
    videos: PropTypes.object,
    stories: PropTypes.object
  }).isRequired,
  recordSearchTerm: PropTypes.func.isRequired
};

HeaderElements.contextTypes = {
  location: PropTypes.object
};

